<template>
  <v-data-table
    :loading="itemsLoading"
    :items="items"
    :headers="visibleColumns"
    hide-actions
    :class="dataTableClass"
    style="overflow: auto"
  >
    <template
      slot="headers"
      slot-scope="props"
    >
      <tr class="text-xs-left px-3" />
      <tr class="text-xs-left px-3">
        <th
          v-for="header in props.headers"
          :key="header.name"
        >
          <span v-if="header.type === 'icon'">
            <v-icon
              small
              color="grey lighten-1"
            >
              {{ header.name }}
            </v-icon>
          </span>
          <span v-else> {{ header.title }}</span>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr :class="{ 'green accent-1': selectedRow == props.index }">
        <td
          v-for="column in visibleColumns"
          :key="column.name"
        >
          <component
            :is="cellEditors[column.editor]"
            v-if="column.editor"
            :value="props.item[column.name]"
            :column="column"
            :item="props.item"
            :item-index="props.index"
            @openEditDialog="openCellEditDialog"
          />
          <span v-else-if="column.type === 'object'">{{
            props.item[column.name] ? props.item[column.name].title : ""
          }}</span>
          <span v-else-if="column.type === 'link'">
            <router-link
              :to="{ name: 'shipping', params: { id: props.item.shippingId } }"
              target="_blank"
            >{{ props.item[column.name] }}</router-link>
          </span>
          <span v-else-if="props.item.tooltip && column.tooltip">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ props.item[column.name] }}
                </span>
              </template>
              <span>{{ props.item[column.name] }}</span>
            </v-tooltip>
          </span>
          <span v-else>{{ props.item[column.name] }}</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { cellEditors } from "./cell-editors/cell-editors.js";
import TextEditor from "./cell-editors/TextEditor.vue";
import LinkCell from "../../../components/LinkCell.vue";
import TransitionStateEditor from "./cell-editors/TransitionStateEditor.vue";

export default {
  components: {
    TextEditor,
    LinkCell,
    TransitionStateEditor,
  },
  props: ["itemsLoading"],
  data() {
    return {
      selectedRow: null,
    };
  },
  computed: {
    headers() {
      return this.$store.getters["warehouseDetails/headers"];
    },
    columnsSettings() {
      return this.$store.getters["warehouseDetails/columns"];
    },
    visibleColumns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        const column = this.columnsSettings.find(sc => sc.name === c.name);
        if (column) {
          c.visible = column.visible;
          c.order = column.order;
        }
      });
      columns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return columns.filter(c => c.visible);
    },
    items() {
      return this.$store.getters["warehouseDetails/items"];
    },
    dataTableClass() {
      if (this.items.length > 10) {
        return "v-data-table--fixed-header";
      } else {
        return "v-data-table--fixed-height";
      }
    },
    cellEditors() {
      return cellEditors;
    },
  },
  methods: {
    openCellEditDialog(index) {
      this.selectedRow = index;
    },
  },
};
</script>
